// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"487":"ade67479","696":"42eb69db"}[chunkId] + ".css";
};